import { render, staticRenderFns } from "./select-envelope-sender-id.vue?vue&type=template&id=25a252b0&scoped=true&"
import script from "./select-envelope-sender-id.vue?vue&type=script&lang=js&"
export * from "./select-envelope-sender-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a252b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a252b0')) {
      api.createRecord('25a252b0', component.options)
    } else {
      api.reload('25a252b0', component.options)
    }
    module.hot.accept("./select-envelope-sender-id.vue?vue&type=template&id=25a252b0&scoped=true&", function () {
      api.rerender('25a252b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/envelopes/partials/select-envelope-sender-id.vue"
export default component.exports